import Service from "../../AuthService";
const Position = {
    getPosition(page) {
        return Service.get("/position?page="+page);
    },
    showPosition(id) {
        return Service.get("/position/" + id);
    },
    updatePosition(id, data) {
        return Service.put("/position/" + id, data);
    },
    createPosition(data) {
        return Service.post("/position", data);
    },
    deletePosition(id) {
        return Service.delete("/position/" + id);
    }
};
export default Position;
